import Image from 'next/image'
import { GlobeEuropeAfricaIcon, GlobeAmericasIcon, GlobeAsiaAustraliaIcon } from '@heroicons/react/24/outline'

import 'flag-icons/css/flag-icons.min.css'

import { Country } from '@/types'
import { cn } from '@/lib/classnames'

interface CountryFlagProps {
  country: Pick<Country, 'code' | 'name'>
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | '3xl'
}

const BalkanIcon = () => (
  <div className={cn('flex items-center justify-center w-5 h-5')}>
    <Image src='/balkan.webp' alt='Balkan' width={20} height={20} />
  </div>
)

const iconMapper: Record<string, JSX.Element> = {
  Asia: <GlobeAsiaAustraliaIcon className='w-6 h-6' />,
  Africa: <GlobeEuropeAfricaIcon className='w-6 h-6' />,
  'North America': <GlobeAmericasIcon className='w-6 h-6' />,
  'South America': <GlobeAmericasIcon className='w-6 h-6' />,
  Oceania: <GlobeAsiaAustraliaIcon className='w-6 h-6' />,
  Global: <GlobeAmericasIcon className='w-6 h-6' />,
  Balkan: <BalkanIcon />,
}

const CountryFlag = ({ country, size = 'sm', className }: CountryFlagProps) => {
  const sizeMapper: Record<string, string> = {
    sm: 'w-6 h-6',
    md: 'w-7 h-7',
    lg: '!w-8 !h-8',
    xl: '!w-10 !h-10',
    xxl: '!w-12 !h-12',
    '3xl': '!w-14 !h-14',
  }
  const sizeClassName = sizeMapper[size] || sizeMapper.sm

  // Europe uses the EU flag from flag-icons so it crops and rounds like every other flag.
  const code = country.code === 'Europe' ? 'eu' : country.code
  const isRegion = code?.length > 2
  if (isRegion) {
    return <div className={cn('flex items-center justify-center', sizeClassName, className)}>{iconMapper[country.code]}</div>
  }
  return <span className={cn(`fi fi-${code}`, sizeClassName, className)} />
}

export default CountryFlag
